import axios from 'axios';
import apiService from '../apiService';

export default async function deleteFaceDetectionsByEvent(eventId = '', system = '') {
  try {
    let _token = await apiService.getUserToken();

    let _request = {
      url: `${apiService.getUrl().faceRecognition}faceDetection/deleteFaceDetectionsByEvent`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `BEARER ${_token}`,
      },
      data: {
        eventId: eventId,
        system: system,
      }
    }
    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return;
  } catch (error) {
    console.log('Error saveFaceDetection', error);
    throw error;
  }
}
